import { render, staticRenderFns } from "./SlideIndex.vue?vue&type=template&id=4d01318c&scoped=true"
import script from "./SlideIndex.vue?vue&type=script&lang=js"
export * from "./SlideIndex.vue?vue&type=script&lang=js"
import style0 from "./SlideIndex.vue?vue&type=style&index=0&id=4d01318c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d01318c",
  null
  
)

export default component.exports